'use client';
import React, { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
  bgColor: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Vladim Reviakin',
    role: 'investor, Russia',
    text: '"I recently purchased a plot in Dubai Sports City via PlotAE, and the experience was nothing short of professional. Their knowledge of land trends and legalities gave me confidence at every step. The location they helped me secure is perfect for future development. Highly recommend their services to anyone looking for land in the UAE!"',
    bgColor: 'bg-[#e8f5e9]',
  },
  {
    id: 2,
    name: 'Sara Al Qassimi',
    role: 'Investor, UAE',
    text: '"I had always dreamed of owning land on Dubai Islands, and PlotAE made it possible. Their team provided end-to-end support, from selecting the right plot to handling all documentation seamlessly. The location is breathtaking, and I\'m excited about the future potential. Truly grateful to PlotAE for making this investment a reality."',
    bgColor: 'bg-[#f1f8e9]',
  },
  {
    id: 3,
    name: 'Sachin Simon',
    role: 'CEO, Smooth Group',
    text: "All Other property portals are dominated by villas and apartments. Plotae is different. It's built specifically for the land investment market. Their exclusive inventory helped me secure a high-return off market plot, without any hassle directly with the seller. Highly recommend Plotae to serious real estate investors looking for trusted land listings",
    bgColor: 'bg-[#e8f5e9]',
  },
  {
    id: 4,
    name: 'Manga Mamtani',
    role: 'Land owner, Sports city',
    text: '"As a landowner, I wanted serious buyers, not just random enquiries. Plotae connected me directly with vetted, qualified investors who were genuinely interested in purchasing my land. The entire process was smooth, transparent, and far more professional than my previous experiences. I\'d recommend Plotae with confidence"',
    bgColor: 'bg-[#f1f8e9]',
  },
  {
    id: 5,
    name: 'Ali Bin Saleh',
    role: 'Investor, Iran',
    text: '"Buying land in JVC (Jumeirah Village Circle) through PlotAE was one of the best investment decisions I\'ve made. The team was incredibly transparent, responsive. I was impressed by how smoothly everything went from site visits to final paperwork. I now have a prime plot in a rapidly developing community, thanks to PlotAE\'s expertise!"',
    bgColor: 'bg-[#e8f5e9]',
  },
];

export default function TestimonialsSection() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-[32px] font-semibold text-[#1a1a1a]">Real Experiences. Real Trust</h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {testimonials.slice(0, 3).map((testimonial) => (
            <div key={testimonial.id} className={`${testimonial.bgColor} rounded-xl p-6`}>
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg
                    key={star}
                    className="w-4 h-4 text-[#017743]"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>
              <p className="text-[14px] text-[#50514f] leading-relaxed mb-4">{testimonial.text}</p>
              <div>
                <p className="text-[14px] font-bold text-[#1a1a1a]">{testimonial.name}</p>
                <p className="text-[12px] text-[#50514f]">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Second Row - 2 testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {testimonials.slice(3, 5).map((testimonial) => (
            <div key={testimonial.id} className={`${testimonial.bgColor} rounded-xl p-6`}>
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg
                    key={star}
                    className="w-4 h-4 text-[#017743]"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>
              <p className="text-[14px] text-[#50514f] leading-relaxed mb-4">{testimonial.text}</p>
              <div>
                <p className="text-[14px] font-bold text-[#1a1a1a]">{testimonial.name}</p>
                <p className="text-[12px] text-[#50514f]">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center gap-2">
          {[0, 1, 2, 3, 4].map((dot) => (
            <button
              key={dot}
              onClick={() => setActiveTab(dot)}
              className={`w-2 h-2 rounded-full transition-colors ${
                activeTab === dot ? 'bg-[#017743]' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
